// extracted by mini-css-extract-plugin
export default {"disabled":"src-components-organisms-node-manager-navigation-buttons-node-manager-navigation-buttons-module__disabled--g0pT8"};